import type { FieldPath, FieldValues } from "react-hook-form";
import {
  CdcTextInputField,
  type CdcTextInputFieldProps,
} from "./cdc-field-helpers";

export type CdcAddressCityFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<
  CdcTextInputFieldProps<TFieldValues, TName>,
  "autoComplete" | "fieldKey" | "inputMode" | "maxLength" | "pattern" | "type"
>;

export function CdcAddressCityField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  required = false,
  ...props
}: Readonly<CdcAddressCityFieldProps<TFieldValues, TName>>) {
  return (
    <CdcTextInputField
      {...props}
      autoComplete="address-level2"
      fieldKey="city"
      required={required}
      type="text"
    />
  );
}
